module.exports = __webpack_public_path__ + "static/img/icon-insurance-03.1ef4c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon-insurance-03.png
// module id = +YZ2
// module chunks = 1